<script setup lang="ts">
    import { ref } from "vue";
    import { useApplicationStore } from "@/stores/Application";

    const appStore = useApplicationStore();
    const logoutModal = ref< HTMLDialogElement >();

    function open() {
            logoutModal.value?.showModal();
        }

    function close() {
            logoutModal.value?.close();
        }

    function signOut() {
        logoutModal.value?.close();
        appStore.logoutAndGoHome().then();
    }

    defineExpose( { open, close } );
</script>

<template>
    <dialog id="logoutModal" ref="logoutModal" class="modal">
        <div class="modal-box">
        <form method="dialog" @click="close">
            <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">✕</button>
        </form>
        <h3 class="text-xl font-bold">Log Out</h3>
        <p class="py-4">Are you sure you want to log out?</p>
        <div class="w-full flex space-x-2">
            <form method="dialog" @click="close" class="w-1/2">
            <button class="btn w-full">Cancel</button>
            </form>
            <button type="button" class="btn btn-primary w-1/2" @click="signOut">Log Out</button>
        </div>
        </div>
        <form method="dialog" class="modal-backdrop" @click.prevent="close">
        <button>close</button>
        </form>
    </dialog>
</template>